import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { ROUTES } from '@/config/routes'
import { 
  trackPersonalPageView, 
  trackBusinessPageView, 
  trackPersonalEvents, 
  trackBusinessEvents, 
  trackGeneralEvents,
  trackPageView 
} from '@/utils/gtm'

// Custom hook for GTM tracking
export const useGTMTracking = () => {
  const location = useLocation()
  // Track all page views
  useEffect(() => {
    const pathname = location.pathname

    // Main application pages
    if (pathname === ROUTES.HOME.path) {
      trackPageView('', 'Application Selection Page')
    } else if (pathname === ROUTES.DEALER.path) {
      trackPageView('dealer', 'Dealer Page')
    } else if (pathname === ROUTES.PERSONAL.ROOT.path) {
      trackPageView('personal', 'Personal - Start Application')
    } else if (pathname === ROUTES.BUSINESS.ROOT.path) {
      trackPageView('business', 'Business - Start Application')
    }

    // Personal loan form steps
    else if (pathname === ROUTES.PERSONAL.YOUR_DETAILS.path) {
      trackPersonalPageView('Your details')
    } else if (pathname === ROUTES.PERSONAL.ABOUT_YOU.path) {
      trackPersonalPageView('About you')
    } else if (pathname === ROUTES.PERSONAL.INCOME.path) {
      trackPersonalPageView('Income')
    } else if (pathname === ROUTES.PERSONAL.FINANCIAL_POSITION.path) {
      trackPersonalPageView('Financial position')
    } else if (pathname === ROUTES.PERSONAL.DOC_UPLOAD.path) {
      trackPersonalPageView('Documents')
    } else if (pathname === ROUTES.PERSONAL.END_APPLICATION.path) {
      trackPersonalPageView('Completed application')
    }
    
    // Business loan form steps
    else if (pathname === ROUTES.BUSINESS.ABOUT_YOUR_BUSINESS.path) {
      trackBusinessPageView('About your business')
    } else if (pathname === ROUTES.BUSINESS.ABOUT_YOU.path) {
      trackBusinessPageView('About you')
    } else if (pathname === ROUTES.BUSINESS.FINANCIAL_POSITION.path) {
      trackBusinessPageView('Financial position')
    } else if (pathname === ROUTES.BUSINESS.APPLICATION_OPTIONS.path) {
      trackBusinessPageView('Application options')
    } else if (pathname === ROUTES.BUSINESS.END_APPLICATION.path) {
      trackBusinessPageView('Thank you')
    }
  }, [location.pathname])

  // Return tracking functions for component-specific events
  return {
    // Personal events
    trackPersonalSubmitApplication: trackPersonalEvents.submitApplication,
    trackPersonalSubmitCoborrowerApplication: trackPersonalEvents.submitCoborrowerApplication,
    trackPersonalClickApplication: trackPersonalEvents.clickApplication,
    trackPersonalClickCoborrowerApplication: trackPersonalEvents.clickCoborrowerApplication,
    trackPersonalClickIncomeVerification: trackPersonalEvents.clickIncomeVerification,
    trackPersonalClickCoborrowerIncomeVerification: trackPersonalEvents.clickCoborrowerIncomeVerification,
    trackPersonalUploadUsed: trackPersonalEvents.uploadUsed,
    trackPersonalUploadErrorSize: trackPersonalEvents.uploadErrorSize,
    trackPersonalUploadErrorType: trackPersonalEvents.uploadErrorType,
    trackPersonalUploadErrorJpeg: trackPersonalEvents.uploadErrorJpeg,
    trackPersonalUploadErrorLength: trackPersonalEvents.uploadErrorLength,
    trackPersonalCallbackRequested: trackPersonalEvents.callbackRequested,
    
    // Business events
    trackBusinessSubmitApplication: trackBusinessEvents.submitApplication,
    trackBusinessClickApplication: trackBusinessEvents.clickApplication,
    trackBusinessClickIncomeVerification: trackBusinessEvents.clickIncomeVerification,
    trackBusinessUploadUsed: trackBusinessEvents.uploadUsed,
    trackBusinessUploadErrorSize: trackBusinessEvents.uploadErrorSize,
    trackBusinessUploadErrorType: trackBusinessEvents.uploadErrorType,
    trackBusinessUploadErrorJpeg: trackBusinessEvents.uploadErrorJpeg,
    trackBusinessUploadErrorLength: trackBusinessEvents.uploadErrorLength,
    
    // General events
    trackApplicationRestart: trackGeneralEvents.applicationRestart
  }
} 